import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ButtonConfigModel } from '../marketing-page.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'platform-integration-button-template',
  imports: [CommonModule, MatButtonModule, TranslateModule],
  templateUrl: './button-template.component.html',
  styleUrl: './button-template.component.scss',
})
export class ButtonTemplateComponent {
  @Input() buttonModel?: ButtonConfigModel;
}
